<template>
    <a @click.prevent="handleClick" class="card-link" v-if="data && data.id">
        <div class="card h-100">
            <div class="row g-0 h-100">
                <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                    <div class="image-container">
                        <img :src="data.img" alt="..." class="card-img">
                    </div>
                </div>

                <div class="col-8 d-flex flex-column h-100">
                    <div class="card-body p-1 d-flex flex-column h-100">
                        <div class="header flex-shrink-0">
                            <h5 class="card-title mt-3">{{ data.name }}</h5>
                            <div class="ri mb-1 mt-2">
                                <i class="bi bi-clock riqiziti" id="upload-date">
                                    <span>&nbsp;{{ data.createTime ? data.createTime.substr(0, 10) : '-' }}&nbsp;&nbsp;</span>
                                </i>
                                <i class="bi bi-star-fill riqiziti" id="collect">
                                    <span>&nbsp;{{ data.collection || 0 }}</span>
                                </i>
                            </div>
                        </div>

                        <!-- 这里只改成三项信息展示 -->
                        <div class="content flex-grow-1">
                            <div class="info-wrap">
                                <div class="info-row">
                                    <span class="info-label">身高：</span>
                                    <span class="info-value">{{ data.height ?? '-' }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">体重：</span>
                                    <span class="info-value">{{ data.weight ?? '-' }}kg</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">年龄：</span>
                                    <span class="info-value">{{ data.age ?? '-' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="footer mb-2 flex-shrink-0">
                            <span class="bi bi-send-fill weiz changlv" id="location">&nbsp;{{ data.source }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: "MaintenanceCard",
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        methods: {
            handleClick() {
                this.$emit('click');
                this.$router.push({
                    name: 'detailPage3',
                    query: { id: this.data.id }
                });
            },
            formatDate(value) {
                if (!value) return '-';
                return String(value).substring(0, 10);
            },
            formatLocation(province, city) {
                if (province && city) return `${province}-${city}`;
                if (province) return province;
                if (city) return city;
                return '-';
            },
            formatHeight(value) {
                if (value === null || value === undefined || value === '') return '-';
                const str = String(value).trim();
                if (str.includes('cm') || str.includes('CM')) return str;
                return `${str} cm`;
            },
            formatWeight(value) {
                if (value === null || value === undefined || value === '') return '-';
                const str = String(value).trim();
                if (str.includes('kg') || str.includes('KG') || str.includes('Kg')) return str;
                return `${str} kg`;
            },
            formatAge(value) {
                if (value === null || value === undefined || value === '') return '-';
                return String(value);
            }
        }
    };
</script>

<style scoped>
    body, .card {
        font-size: 16px;
    }

    .card {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        border: none;
    }

    .col-4 {
        width: 115px;
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0;
    }

    .image-container {
        width: 99px;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 4px;
    }

    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .col-8 {
        max-height: 155px;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        padding: 0.1rem;
        height: 100%;
    }

    .card-title {
        font-size: 1rem;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }


    .daxiao {
        font-size: 0.75rem !important;
    }

    .ri {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
    }

    .riqiziti {
        font-style: normal;
        font-size: 0.8rem;
        margin-right: 4px;
    }

    .ri i + i {
        margin-left: 4px;
    }

    .changlv {
        color: #18b371 !important;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 0.2rem;
        min-height: 42px;
    }

    .info-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        line-height: 1.5;
    }

    .info-row {
        display: inline-flex;
        align-items: center;
        margin-right: 20px;
        margin-bottom: 2px;
        font-size: 0.9rem;
        color: #222;
        white-space: nowrap;
    }

    .info-label {
        color: #222;
    }

    .info-value {
        color: #111;
    }

    .card-link {
        text-decoration: none;
        color: inherit;
    }

    .weiz {
        font-size: 0.9rem;
    }

    /*.top-flag {
      font-size: 0.8rem;
      z-index: 10;
    }*/
</style>
